/**
 * Runs before the Redux store is created so that auth slice initial state
 * is computed from storage after clear (avoids loggedIn true with no token on browser reopen).
 */
import { clearStorageIfNewBrowserSession, syncSessionFromLocalStorage } from './CommonMethods/authSession';

clearStorageIfNewBrowserSession();
syncSessionFromLocalStorage();
